import "core-js/stable";
import "regenerator-runtime/runtime";
import { initComponents } from './Utils/loadComponents'

import "./Vendor/moduler";
import "./Vendor/jquery.validate";
import "./Vendor/jquery.validate.unobtrusive";
import "./Vendor/jquery.inputmask";

import legacy        from './LegacyComponents/legacy'
import nav           from './LegacyComponents/nav'
import tooltip       from './LegacyComponents/tooltip'
import scrollto      from './LegacyComponents/scrollto'
import accordion     from './LegacyComponents/accordion'
import heroAccordion from './LegacyComponents/heroaccordion'
import findaform     from './LegacyComponents/findaform'
import contact       from './LegacyComponents/contact'
import tabs          from './LegacyComponents/tabs'
import social        from './LegacyComponents/social'
import compatibility from './LegacyComponents/compatibility'
import animatedicon  from './LegacyComponents/animatedicon'
import animatedhero  from './LegacyComponents/animatedhero'
import audio         from './LegacyComponents/audio'
import select        from './LegacyComponents/select'
import modal         from './LegacyComponents/modal'
import carousel      from './LegacyComponents/carousel'
import session       from './LegacyComponents/session'
import tableSort     from './LegacyComponents/table-sort'
import xhrForm       from './LegacyComponents/xhr-form'

// This is the Nansen loadComponents framework, that we use for all our current episerver projects. It
// makes it possible to load components on page load from bundle, or on demand from chunk. The components
// are loaded and started based on the html on the page, with data-js and data-js-settings attributes.
initComponents()

// generate svg sprite from all files in /Assets/Images/SVG
const files = require.context('../Images/SVG', false, /.*\.svg$/)
files.keys().forEach(files)

//when this resolves, then do the rest
tooltip()
legacy()
scrollto.init()
session()
nav()
accordion()
heroAccordion()
tabs()
findaform()
contact()
social()
compatibility.init()
animatedicon()
animatedhero()
audio()
select()
carousel()
modal()
tableSort()
xhrForm()

import "./Vendor/backtotop";

